import type { FaireProductEntity } from "../../entity_types/product";

export const p_22atpf5sth: FaireProductEntity = {
  token: "p_22atpf5sth",
  type: "product",
  name: "Wild Oregano Oil | Support Immunity | 6 Months Supply | 1 oz",
  brandToken: "b_v59f599x2t",
  brandName: "Plant of Life",
  imageUrl:
    "https://cdn.faire.com/fastly/b99b0e220d3a23081397dfa5d42d62f1f356f81ac3c4d8a964682c3a0533f6ff.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98a9bf12f701c2685da8266be247639e667e72f36482a19088fb06add816eff4.jpeg",
    "https://cdn.faire.com/fastly/7a58ace5b2d918e6f58b472113ec15cab5b6454b02d1e3bba5cc0ffe47a188f4.jpeg",
    "https://cdn.faire.com/fastly/d6b97895785082de0269b80c63f8f8e0d7b5b4410484c24e7c860ee8ab4b4c90.jpeg",
    "https://cdn.faire.com/fastly/0e6c4c8012f7045ee6cfe2f877c7e731af2fb18af3432ba851bde31303bd5a91.jpeg",
    "https://cdn.faire.com/fastly/a035ed86545b72e9d324e5d2e91e54c62adfbf4481e40b3e1284efe53d134b6d.jpeg",
    "https://cdn.faire.com/fastly/a43ab53f41ed8b9cddccabb40e906ce7aa147ec9db53cb7b0d1fbeb80deb282b.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "Plant of Life Wild Oregano Oil - A 6 Months Supply in a 1 oz (30ml) Bottle!\n\nUnlock the power of Wild Oregano Oil, a natural elixir known for its numerous health benefits. Crafted with care, our Plant of Life Wild Oregano Oil offers a generous 6 months supply in a convenient 1 oz (30ml) bottle.\n\nKey Features:\n\nPotent Wild Oregano Oil: Our oil is derived from wild oregano plants, ensuring a potent and pure formulation with high levels of active compounds that offer health benefits.\n\nNatural Health Support: Wild Oregano Oil has been celebrated for centuries for its immune-supporting properties and for promoting overall wellness.\n\n6-Months Supply: With our 1 oz bottle, you have a generous 6 months supply of Wild Oregano Oil, allowing you to enjoy its benefits for an extended period.\n\nEasy-to-Use: The compact 1 oz bottle makes it convenient to carry and use on the go. Simply take the recommended dosage daily to experience the power of Wild Oregano Oil.",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:25.281Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
